import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "./components/Header";
import Button from "./components/Button";
import { toast } from "react-toastify";

const backend_url = process.env.REACT_APP_BACKEND_SERVICE_URL;
// const backend_url = "https://datagenx-backend-srv-801923314065.europe-west3.run.app";

function AuthPage({ onLogin }) {
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [registerData, setRegisterData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    companyName: "",
    jobTitle: "",
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const location = useLocation();
  const isRegisterRoute = location.pathname === "/register";
  const [rememberMe, setRememberMe] = useState(false);
  const [isRegisterLoading, setIsRegisterLoading] = useState(false);
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  const inputStyle = {
    width: "100%",
    padding: "12px 16px",
    marginBottom: "15px",
    border: "1px solid #4B4B4B",
    borderRadius: "5px",
    fontSize: "16px",
    background: "transparent",
  };
  const handleCheckboxChange = (e) => {
    const newValue = e.target.checked;
    setRememberMe(newValue);
    console.log(newValue);
  };
  const navigate = useNavigate();

  const handleLogin = async () => {
    setError("");
    setIsLoginLoading(true);
    try {
      const response = await fetch(backend_url + "/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: loginEmail, password: loginPassword }),
      });
      const data = await response.json();
      if (data.success) {
        const { name, userId } = data;
        onLogin(name, userId);
      } else {
        toast.error("Invalid credentials.");
      }
    } catch (err) {
      toast.error("Network or server error.");
    } finally {
      setIsLoginLoading(false);
    }
  };

  const handleRegister = async () => {
    if (registerData.password !== registerData.confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }
    setIsRegisterLoading(true);
    try {
      const response = await fetch(backend_url + "/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(registerData),
      });
      const data = await response.json();
      if (data.success) {
        toast.success("Registration successful!");
        setRegisterData({
          firstName: "",
          lastName: "",
          email: "",
          companyName: "",
          jobTitle: "",
          password: "",
          confirmPassword: "",
        });
        navigate("/login");
      } else {
        toast.error("Error during registration.");
      }
    } catch (err) {
      toast.error("Network or server error.");
    } finally {
      setIsRegisterLoading(false);
    }
  };

  return (
    <>
      <Header />
      {isRegisterRoute ? (
        <div
          className="py-20 min-h-screen"
          style={{ backgroundImage: "url(/auth.png)", backgroundSize: "cover" }}
        >
          <div className="container mx-auto px-4 md:px-6 lg:px-8 flex flex-col lg:flex-row items-start lg:items-center justify-center gap-10 lg:gap-20">
            <img src="/logo3.svg" alt="logo" />
            <div
              className="p-5 lg:px-24 lg:py-16"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                width: "100%",
                maxWidth: "600px",
                background: "rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(10px)",
                borderRadius: "10px",
                boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
                border: "2px solid rgba(255, 255, 255, 0.3)",
              }}
            >
              <div
                style={{
                  marginBottom: "20px",
                }}
              >
                <h2
                  style={{
                    color: "var(--color-primary)",
                    fontSize: "35px",
                    fontWeight: "600",
                  }}
                >
                  Create Account
                </h2>
                <div
                  style={{ display: "flex", gap: "3px", alignItems: "center" }}
                >
                  <span style={{ color: "#4B4B4B", fontSize: "14px" }}>
                    Already have an account?
                  </span>
                  <Link
                    to="/login"
                    style={{
                      color: "rgba(68, 42, 208, 1)",
                      fontSize: "15px",
                    }}
                  >
                    Sign in
                  </Link>
                </div>
              </div>
              <input
                type="text"
                placeholder="First Name"
                value={registerData.firstName}
                onChange={(e) =>
                  setRegisterData({
                    ...registerData,
                    firstName: e.target.value,
                  })
                }
                style={inputStyle}
                className=" placeholder-gray-500"
              />
              <input
                type="text"
                placeholder="Last Name"
                value={registerData.lastName}
                onChange={(e) =>
                  setRegisterData({ ...registerData, lastName: e.target.value })
                }
                style={inputStyle}
                className=" placeholder-gray-500"
              />
              <input
                type="email"
                placeholder="Email Address"
                value={registerData.email}
                onChange={(e) =>
                  setRegisterData({ ...registerData, email: e.target.value })
                }
                style={inputStyle}
                className=" placeholder-gray-500"
              />
              <input
                type="text"
                placeholder="Company Name"
                value={registerData.companyName}
                onChange={(e) =>
                  setRegisterData({
                    ...registerData,
                    companyName: e.target.value,
                  })
                }
                style={inputStyle}
                className=" placeholder-gray-500"
              />
              <input
                type="text"
                placeholder="Job Title"
                value={registerData.jobTitle}
                onChange={(e) =>
                  setRegisterData({ ...registerData, jobTitle: e.target.value })
                }
                style={inputStyle}
                className=" placeholder-gray-500"
              />
              <input
                type="password"
                placeholder="Password"
                value={registerData.password}
                onChange={(e) =>
                  setRegisterData({ ...registerData, password: e.target.value })
                }
                style={inputStyle}
                className=" placeholder-gray-500"
              />
              <input
                type="password"
                placeholder="Confirm Password"
                value={registerData.confirmPassword}
                onChange={(e) =>
                  setRegisterData({
                    ...registerData,
                    confirmPassword: e.target.value,
                  })
                }
                style={inputStyle}
                className=" placeholder-gray-500"
              />
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <Button
                  content="REGISTER"
                  className="w-full md:w-24"
                  onClick={handleRegister}
                  isLoading={isRegisterLoading}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="flex items-center justify-center py-10 min-h-screen"
          style={{
            backgroundImage: "url(/auth.png)",
            backgroundSize: "cover",
          }}
        >
          <div className="container mx-auto px-4 md:px-6 lg:px-8 flex items-center justify-center">
            <div
              className="px-5 py-8 lg:px-7 lg:py-12"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                width: "100%",
                maxWidth: "600px",
                background: "rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(10px)",
                borderRadius: "10px",
                boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
                border: "2px solid rgba(255, 255, 255, 0.3)",
              }}
            >
              <div style={{ marginBottom: "20px" }}>
                <h2
                  style={{
                    color: "var(--color-primary)",
                    fontSize: "35px",
                    fontWeight: "600",
                  }}
                >
                  Sign in
                </h2>
                <div
                  style={{
                    display: "flex",
                    gap: "3px",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <span style={{ color: "#4B4B4B", fontSize: "14px" }}>
                    New user?
                  </span>
                  <Link
                    to="/register"
                    style={{
                      color: "rgba(68, 42, 208, 1)",
                      fontSize: "15px",
                    }}
                  >
                    Create an account
                  </Link>
                </div>
              </div>

              <input
                type="email"
                placeholder="Email address"
                value={loginEmail}
                onChange={(e) => setLoginEmail(e.target.value)}
                style={inputStyle}
                className="placeholder-gray-500"
              />
              <input
                type="password"
                placeholder="password"
                value={loginPassword}
                onChange={(e) => setLoginPassword(e.target.value)}
                style={inputStyle}
                className="placeholder-gray-500"
              />
              <div className="w-full flex flex-wrap items-center justify-between mb-4">
                <label className="flex items-center gap-2 cursor-pointer select-none">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={handleCheckboxChange}
                    className="hidden"
                  />

                  <div className="w-4 h-4 rounded border-2 border-gray-400 flex items-center justify-center bg-transparent">
                    {rememberMe && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-3 h-3 text-black"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={3}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    )}
                  </div>

                  <span className="text-sm text-gray-700">Remember me</span>
                </label>

                <Link
                  to="/"
                  className="text-sm"
                  style={{ color: "rgba(68, 42, 208, 1)" }}
                >
                  Forgot password
                </Link>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <Button
                  content={"CONTINUE"}
                  className="w-full md:w-24"
                  onClick={handleLogin}
                  isLoading={isLoginLoading}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {error && <p className="auth-error">{error}</p>}
    </>
  );
}

export default AuthPage;
